// Generated by purs version 0.15.0
import * as Data_Array_NonEmpty_Serialized from "../Data.Array.NonEmpty.Serialized/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_MultiSet from "../Data.MultiSet/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic_CoreSites_Translations_Keys from "../Restaumatic.CoreSites.Translations.Keys/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_Menu_V2_MenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic_Menu_V2_Types_Allergen from "../Restaumatic.Menu.V2.Types.Allergen/index.js";
import * as Restaumatic_Menu_V2_Types_CartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_Modifier from "../Restaumatic.Menu.V2.Types.Modifier/index.js";
import * as Restaumatic_Menu_V2_Types_Product from "../Restaumatic.Menu.V2.Types.Product/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var translatedAllergen = function (v) {
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Gluten) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Gluten);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Crustaceans) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Crustaceans);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Eggs) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Eggs);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Fish) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Fish);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Peanuts) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Peanuts);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Soybeans) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Soybeans);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Milk) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Milk);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Nuts) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Nuts);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Celery) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Celery);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Mustard) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Mustard);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Sesame) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Sesame);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.SulphurDioxide) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.SulphurDioxide);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Lupin) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Lupin);
    };
    if (v instanceof Restaumatic_Menu_V2_Types_Allergen.Molluscs) {
        return Restaumatic_I18n.translate_(Restaumatic_CoreSites_Translations_Keys.t.allergens.Molluscs);
    };
    throw new Error("Failed pattern match at Restaumatic.Menu.V2.Allergens (line 44, column 3 - line 58, column 60): " + [ v.constructor.name ]);
};
var productKeyAllergens = function (catalogue) {
    return function (productKey) {
        var productAllergens = function (productId) {
            return Data_Maybe.maybe(Data_Monoid.mempty(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_Allergen.ordAllergen)))((function () {
                var $8 = Data_Newtype.unwrap();
                return function ($9) {
                    return Data_Map.keys($8((function (v) {
                        return Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "allergens";
                            }
                        })()))(Type_Proxy["Proxy"].value)(v);
                    })($9)));
                };
            })())(Restaumatic_Menu_V2_MenuCatalogue.lookupProduct(catalogue)(productId));
        };
        var modifierValuesAllergens = function (modifierValues) {
            return Data_Foldable.foldMap(Data_Foldable.foldableArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_Allergen.ordAllergen))(function (v) {
                var itemMap = Data_Maybe.maybe(Data_Monoid.mempty(Data_Map_Ordered.monoidOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)))(Restaumatic_Menu_V2_MenuCatalogue.modifierItems)(Restaumatic_Menu_V2_MenuCatalogue.lookupModifier(catalogue)(v.value0));
                return Data_Foldable.foldMap(Data_Foldable.foldableArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_Allergen.ordAllergen))(function (itemId) {
                    return Data_Maybe.maybe(Data_Monoid.mempty(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_Allergen.ordAllergen)))((function () {
                        var $10 = Data_Newtype.unwrap();
                        return function ($11) {
                            return Data_Map.keys($10((function (v1) {
                                return Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifierItem(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "allergens";
                                    }
                                })()))(Type_Proxy["Proxy"].value)(v1);
                            })($11)));
                        };
                    })())(Data_Map_Ordered.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(itemId)(itemMap));
                })(Data_MultiSet.distinctElems(Data_Newtype.unwrap()(v.value1)));
            })(Data_Map_Internal.toUnfoldableUnordered(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(modifierValues)));
        };
        return Data_Semigroup.append(Data_Set.semigroupSet(Restaumatic_Menu_V2_Types_Allergen.ordAllergen))(modifierValuesAllergens(Data_Record.getField(Restaumatic_Menu_V2_Types_CartToOrder.hasFieldCartProductKey(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "modifiers";
            }
        })()))(Type_Proxy["Proxy"].value)(productKey)))(Data_Foldable.foldMap(Data_Array_NonEmpty_Serialized.foldableNonEmptyArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_Allergen.ordAllergen))(function (part) {
            return Data_Semigroup.append(Data_Set.semigroupSet(Restaumatic_Menu_V2_Types_Allergen.ordAllergen))(modifierValuesAllergens(Data_Record.getField(Restaumatic_Menu_V2_Types_CartToOrder.hasFieldCartProductPartKe(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "modifiers";
                }
            })()))(Type_Proxy["Proxy"].value)(part)))(productAllergens(Data_Record.getField(Restaumatic_Menu_V2_Types_CartToOrder.hasFieldCartProductPartKe(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "productId";
                }
            })()))(Type_Proxy["Proxy"].value)(part)));
        })(Data_Record.getField(Restaumatic_Menu_V2_Types_CartToOrder.hasFieldCartProductKey(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "parts";
            }
        })()))(Type_Proxy["Proxy"].value)(productKey)));
    };
};
export {
    productKeyAllergens,
    translatedAllergen
};
//# sourceMappingURL=index.js.map
